import { render } from "./createuser_page.vue?vue&type=template&id=2dc1b95e"
import script from "./createuser_page.vue?vue&type=script&lang=js"
export * from "./createuser_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__